import script from "./PrivaterChatView.vue?vue&type=script&setup=true&lang=js"
export * from "./PrivaterChatView.vue?vue&type=script&setup=true&lang=js"

import "./PrivaterChatView.vue?vue&type=style&index=0&id=61ad6ce7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61ad6ce7"]])

export default __exports__